interface ButtonProps {
    className?: string;
    color?: string;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    size?: string;
    disabled?: boolean;
    [key: string]: any;
}

const Button = ({ className, children, color, onClick, size, disabled, ...rest }: ButtonProps) => {
    return (
        <button
            {...rest}
            disabled={disabled}
            // tabIndex={-1}
            onClick={onClick}
            className={`${className} ${size === "L" ? "w-[195px] h-[56px] text-[18px]" : "h-[38px] px-[14px]"} font-semibold border rounded-lg flex whitespace-nowrap items-center justify-center ${color === "new" ? "border-new text-new" : "border-[#E1E2E4] text-[#878A93]"}`}
        >
            {children}
        </button>
    );
};

export default Button;
